import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import Tab, { Tabs } from '@/components/elements/Button/TabButton';

export enum ScheduleContentType {
  Calendar = 'calendar',
  GradeRace = 'gradeRace',
}

interface ScheduleContentSelectorProps {
  scheduleContentType: ScheduleContentType;
}

const ScheduleContentSelector: FC<ScheduleContentSelectorProps> = ({
  scheduleContentType,
}) => {
  const navigate = useNavigate();
  return (
    <Tabs styles={{ width: ['100'] }}>
      <Tab
        active={scheduleContentType === ScheduleContentType.Calendar}
        onClick={() => navigate('/calendar')}
      >
        開催中
      </Tab>
      <Tab
        active={scheduleContentType === ScheduleContentType.GradeRace}
        onClick={() => navigate('/graderace')}
      >
        グレードレース
      </Tab>
    </Tabs>
  );
};

export default ScheduleContentSelector;
